import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import storage from "@src/shared/utils/localStorage";
import { getLocalTimezone } from "@src/shared/utils/timezone";

export interface AppStore {
  practiceTimezone: string | undefined;
  userTimezone: string;
  setPracticeTimezone: (practiceTimezone: string | undefined) => void;
}

export const appStore = create<AppStore>()(
  persist(
    (set) => ({
      practiceTimezone: undefined,
      setPracticeTimezone: (practiceTimezone) => {
        set((state) => {
          return {
            ...state,
            practiceTimezone,
          };
        });
      },
      userTimezone: getLocalTimezone(),
    }),
    {
      name: "app-store",
      storage: createJSONStorage(() => storage),
    },
  ),
);

/**
 * Returns the timezone used for local date display and serialization.
 */
export function useEffectiveTimezone(): string {
  const practiceTimezone = useAppStore((state) => state.practiceTimezone);
  const userTimezone = useAppStore((state) => state.userTimezone);
  return practiceTimezone || userTimezone;
}

export const useAppStore = appStore;
